import { useDispatch, useSelector } from 'react-redux';

import { pushParams, replace } from 'dpl/actions/query_params';
import { addToQuery } from 'dpl/util/queryString';

import {
  TAB_KEYS,
  MOBILE_TAB_KEYS,
  TAB_NAMES,
  MOBILE_TAB_NAMES,
  TAB_VIEW_FEATURE_LOCATIONS
} from '../utils/constants';
import useBreederProfileMobileLayout from './useBreederProfileMobileLayout';

export default function useBreederProfileTabs() {
  const dispatch = useDispatch();

  const {
    testimonialsCount,
    hasBreederPosts,
    hasPastPuppies,
    hasCurrentLittersDesktop // desktop version excludes adults
  } = useSelector(({ server }) => server);

  const { isNewMobileLayout } = useBreederProfileMobileLayout();
  const tabKeys = isNewMobileLayout ? MOBILE_TAB_KEYS : TAB_KEYS;
  const tabNames = isNewMobileLayout ? MOBILE_TAB_NAMES : TAB_NAMES;

  const enabledTabKeyValues = Object.values(tabKeys).filter(tabKey => {
    switch (tabKey) {
      case TAB_KEYS.DOGS: {
        return (
          !isNewMobileLayout && (hasCurrentLittersDesktop || hasPastPuppies)
        );
      }
      case TAB_KEYS.UPDATES: {
        return hasBreederPosts;
      }
      case TAB_KEYS.STORIES: {
        return testimonialsCount > 0;
      }
      default: {
        return true;
      }
    }
  });

  const enabledTabNameValues = Object.values(
    enabledTabKeyValues.map(tabKey => tabNames[tabKey])
  );

  const defaultTab = isNewMobileLayout
    ? MOBILE_TAB_KEYS.OVERVIEW
    : TAB_KEYS.OVERVIEW;

  const activeTabKey = useSelector(({ queryParams: { tab } }) =>
    enabledTabKeyValues.includes(tab) ? tab : defaultTab
  );

  const activeTabIndex = enabledTabKeyValues.indexOf(activeTabKey);
  const viewFeatureLocation = TAB_VIEW_FEATURE_LOCATIONS[activeTabKey];

  function replaceHash(tabKey) {
    const originalHash = window.location.hash;
    const newHash = addToQuery({ tab: tabKey }, originalHash);

    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}${window.location.search}#${newHash}`
    );

    dispatch(replace(newHash, { hash: true }));
  }

  function handleTabClick(tabIndex) {
    const tabKey = enabledTabKeyValues[tabIndex] || defaultTab;

    if (isNewMobileLayout) {
      replaceHash(tabKey);
    } else {
      dispatch(pushParams({ tab: tabKey }, { hash: true }));
    }

    window.scrollTo(0, 0);
  }

  return {
    activeTabIndex,
    activeTabKey,
    tabNames: enabledTabNameValues,
    tabKeys: enabledTabKeyValues,
    onTabClick: handleTabClick,
    isNewMobileLayout,
    viewFeatureLocation,
    replaceHash
  };
}
